import axios from 'axios';

// Global variable to store the auth token
let authToken = null;

// Function to set the auth token
export const setAuthToken = (token) => {
  authToken = token;
};

// Configure API base URL - this should be set to your API Gateway endpoint
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://1og6ew7ohl.execute-api.eu-west-1.amazonaws.com/dev';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for logging and authentication
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config);
    
    // Add authorization header if token is available
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error);
    return Promise.reject(error);
  }
);

/**
 * Get employee transaction data for a specific time period
 * @param {string} employeeName - Employee Name
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise} API response with transaction data
 */
export const getEmployeeTransactions = async (employeeName, startDate, endDate) => {
  try {
    const response = await api.get('/transactions', {
      params: {
        employee_name: employeeName,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employee transactions:', error);
    throw error;
  }
};

/**
 * Get spending summary for an employee in a time period
 * @param {string} employeeName - Employee Name
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise} API response with spending summary
 */
export const getSpendingSummary = async (employeeName, startDate, endDate) => {
  try {
    const response = await api.get('/spending-summary', {
      params: {
        employee_name: employeeName,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching spending summary:', error);
    throw error;
  }
};

/**
 * Get frequently bought items for an employee in a time period
 * @param {string} employeeName - Employee Name
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise} API response with frequently bought items
 */
export const getFrequentlyBoughtItems = async (employeeName, startDate, endDate) => {
  try {
    const response = await api.get('/frequently-bought', {
      params: {
        employee_name: employeeName,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching frequently bought items:', error);
    throw error;
  }
};

export default api;